import {resourceSchema} from "./resource";
import {draftSchema} from "./draft";
import {baseSchema} from "./base";
import {participantSchema} from "./participant";
import {sealSchema} from "./seal";
import {attachmentSchema} from "./attachment";
import {processSchema} from "./process";
import {extractSchema} from "./extract";
import {instanceSchema} from "./instance";
import {historySchema} from "./history";

export const documentSchema = {
    ...resourceSchema,
    ...draftSchema,
    ...baseSchema,
    ...participantSchema,
    ...sealSchema,
    ...attachmentSchema,
    ...processSchema,
    ...extractSchema,
    ...instanceSchema,
    ...historySchema,
} as const;
